<template>
  <div :class="'bg-' + content[page].color" class="my-12">
    <section class="page-content text-white">
      <h3 class="text-xl lg:text-title  font-bold mb-10">Parlagli di me.</h3>
      <p>Se conosci qualcuno che ha bisogno di realizzare {{ content[page].object }} <span class="text-black font-bold">parlagli di me!</span>
      </p>
      <p class="text-xl lg:text-title mb-0 font-bold">per te e per lui uno sconto fino al <span class="text-title text-black lg:text-big">{{ content[page].discount[2] }}%</span></p>
      <p>{{ content[page].subject }}</p>

      <p class="text-button text-opacity-75 font-light">L’entità dello sconto dipenderà dal servizio che viene acquistato.</p>
    </section>
  </div>
</template>

<script>
  export default {
    name: "TellMe",
    props: {
      page: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        content: {
          webSite: {
            color: 'blue',
            object: 'un sito web',
            discount: [10,20,30],
            subject: 'sui servizi di manutenzione annuale del sito web!',
          },
          singleWebSite: {
            color: 'cyan',
            object: 'un sito web',
            discount: [10,20,30],
            subject: 'sui servizi di manutenzione annuale del sito web!',
          },
          webApp: {
            color: 'darth',
            object: 'una web app',
            discount: [5,10,15],
            subject: 'sui servizi di manutenzione annuale!',
          },
          mobileApp: {
            color: 'salmon',
            object: 'un\'app mobile',
            discount: [5,10,15],
            subject: 'sui servizi di manutenzione annuale della tua app!',
          }
        }
      }
    }
  }
</script>

<style scoped>
  .text-big {
    color: black;
    font-weight: 700;
  }

  .text-opacity-50 {
    opacity: 0.5;
  }

  .text-opacity-75 {
    opacity: 0.75;
  }
</style>